import { DialogProps, DisputeDialog, DisputeEventData, DisputeEventResult } from 'components';
import { DisputeEventTypes } from 'enums';
import { useDisputeService } from 'services';

/**
 * AddNote component allows the user to add a note to a dispute.
 * 
 * @param props - Additional properties passed to the Dialog
 * @returns Rendered component
 */
const AddNote = (props: DialogProps) => {
    const disputeService = useDisputeService();
    const onSubmit = async (data: DisputeEventData) => {
        const result = await disputeService?.addNote(data.disputeNumber, { ...data, eventTypeId: DisputeEventTypes.NoteAdded });
        return {
            error: !result && 'Error saving note'
        } as DisputeEventResult;
    };

    return (
        <DisputeDialog
            initialValues={{ isPublic: false }}
            title="Add Note"
            submitLabel="Save"
            submittingLabel="Saving"
            onSubmit={onSubmit}
            refreshDispute={false}
            {...props}
        />
    );
};

export default AddNote;